// extracted by mini-css-extract-plugin
export default {"checkbox":"checkbox_checkbox__YlOyn","checkboxInput":"checkbox_checkboxInput__Vxc8T","checkboxMark":"checkbox_checkboxMark__1mvUq"};